<template lang="html">
  <div>
    <pos-sales-area-item v-model="selectedItemId" />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import PosSalesAreaItem from './PosSalesAreaItem'

export default {
  name: 'PosSalesAreaList',
  components: {PosSalesAreaItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Event Type',
      types: 'Event Types',
      headers: [
        this.headerText('Event Type Name', 'name', true),
        this.headerText('Comments', 'notes', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'diningEventType'
    }
  },
  computed: {
  }
}
</script>
